import { render, staticRenderFns } from "./PDPDesktopNavPricingSticky.vue?vue&type=template&id=6d86715d&scoped=true&"
import script from "./PDPDesktopNavPricingSticky.vue?vue&type=script&lang=js&"
export * from "./PDPDesktopNavPricingSticky.vue?vue&type=script&lang=js&"
import style0 from "./PDPDesktopNavPricingSticky.vue?vue&type=style&index=0&id=6d86715d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d86715d",
  null
  
)

export default component.exports